/**
 * @module "model/answer.value.model"
 */

define('formkit/model/answer.value.model',['require','exports','module','underscore','./base.model'],function(require, exports, module) {
  //prettier-ignore
  var _ = require('underscore'),
      BaseModel = require('./base.model');

  /**
   * @class AnswerValueModel
   * @augments BaseModel
   */
  var AnswerValueModel = BaseModel.extend({
    /**
     * @lends AnswerValueModel.prototype
     */
    defaults: {
      value: null,
    },

    /**
     * @method initialize
     * @constructs
     * @augments BaseModel
     */
    initialize: function() {
      BaseModel.prototype.initialize.apply(this, arguments);
      this.valueUpdateTimestamp = new Date().getTime();
    },

    /**
     * This is an override that sets the key value pair and checks to see if the
     * data that has been passed is from the server and checks if the model is
     * newly created. If so, remove the 'failed validations'.
     *
     * Interesting Note: Commit a2ac2b3:Fixed issue where the server would
     * override values that had been updated on the frontend
     *
     * @param {string} key - Can be string or an object
     * @param {string} value - Value to set
     * @param {collection} options - collection of option values
     * @return {Object} Returns a model with the set value.
     */
    set: function(key, value, options) {
      var attr, attrs, setter;
      // Normalize the key-value into an object
      if (_.isString(key)) {
        attrs = {};
        attrs[key] = value;
      } else {
        attrs = _.clone(key);
        options = value;
      }

      if (_.result(options, 'isFromServer')) {
        if (options.requestTimestamp <= this.valueUpdateTimestamp) {
          attrs = _.omit(attrs, 'value', 'failedValidations');
        }
      } else if (_.has(attrs, 'value')) {
        this.valueUpdateTimestamp = new Date().getTime();
      }

      return BaseModel.prototype.set.call(this, attrs, options);
    },
  });

  module.exports = AnswerValueModel;
});

